export class Prevelage {
    constructor(role) {
        this.role = role
    }
    canDeleteUser() {
        return [ "superadmin", "admin", "subadmin" ].includes(this.role)
    }
    canUpdateUser() {
        return [ "superadmin", "admin", "subadmin" ].includes(this.role)
    }
    canCreateUser() {
        return [ "superadmin", "admin", "subadmin" ].includes(this.role)
    }
    canManageDocuments() {
        return [ "superadmin", "admin", "subadmin" ].includes(this.role)
    }
    canManageAIGuide() {
        return [ "superadmin", "admin" ].includes(this.role)
    }
    canManageSubjects() {
        return [ "superadmin", "admin", "subadmin" ].includes(this.role)
    }
    // Matches attendanceController.js's getFacultyAttendance/setFacultyAttendance
    // gate exactly (["admin","superadmin"].includes(this.role)) — subadmin is
    // NOT included here, unlike most of the other canXxx() checks above.
    canViewAllFacultyAttendance() {
        return [ "superadmin", "admin" ].includes(this.role)
    }
    canOverrideFacultyAttendance() {
        return [ "superadmin", "admin" ].includes(this.role)
    }
    // Matches the server's CASL `update institute` (user/setInstituteType)
    canSetInstituteType() {
        return [ "superadmin", "admin" ].includes(this.role)
    }
}